export default "__VITE_ASSET__zwQCY0mm__"